import { Component, OnInit } from '@angular/core';
import { TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { QueryOperand } from 'src/app/components/grid/QueryOperand';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';

@Component({
  selector: 'app-exam-schedule-backups',
  templateUrl: './exam-schedule-backups.component.html',
  styleUrls: ['./exam-schedule-backups.component.scss']
})
export class ExamScheduleBackupsComponent implements OnInit {

  gridName = 'examScheduleBackupsGrid';
  constructor(private examSchService: ExamScheduleService, private eventService: EventService) {

  }

  async ngOnInit() {
    GridUtil.setClearGridSelection();
    this.refreshData();
  }
  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [
        {
          fieldName: 'examNo',
          fieldValue: `${this.examSchService.selectedSchedules[0]?.examNo}`,
          queryOperand: QueryOperand['=='],
          static: true
        },
        {
          fieldName: 'examinationID',
          fieldValue: `${this.examSchService.selectedSchedules[0]?.examinationID}`,
          queryOperand: QueryOperand['=='],
          static: true
        }
      ],
      sortParam: {
        fieldName: "",
        orderDirection: 0,
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Examination No',
      fieldName: 'examNo',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Examination ID',
      fieldName: 'examinationID',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Start Date Time',
      fieldName: 'startDateTime',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Actual Start Date Time',
      fieldName: 'actualStartDateTime',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'End Date Time',
      fieldName: 'endDateTime',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Actual End Date Time',
      fieldName: 'actualEndDateTime',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Status',
      fieldName: 'status',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Score',
      fieldName: 'score',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Percentage Score',
      fieldName: 'percentageScore',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Attempt',
      fieldName: 'attempt',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Network Availability Score',
      fieldName: 'networkAvailabilityScore',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    }
  ];

  onRowClick(idx: any) {
    if (!this.data?.tableRows) { //Just in case tableRows might still not be ready
      setTimeout(() => this.onRowClick(idx), 50);
      return;
    }
    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const selectedScheduleBackUp: any[] = idx.map(x => this.data.tableRows[x]).filter(Boolean);
    let selectedDataRowsId = storedIds.length > 0 ? storedIds : selectedScheduleBackUp.map(x => x.id);
    GridUtil.setRowCliclk(this.gridName, idx, selectedDataRowsId);
  }

  async refreshData() {
    const res = await this.examSchService.getExaminationSchedulesBackup(this.data.tableParams) as [];
    if (!res || res.length === 0) {
      return;
    }
    this.data.tableRows = res.slice(1, res.length);
    this.data.tableRows = res.slice(1, res.length);
    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    });
  }

}
